// Build flavor. Set REACT_APP_FLAVOR=doctor at build time to produce the separate
// "Revive Doctor" app: root screen becomes the doctor dashboard, login is the
// doctor (email) gate, and the patient shop tab bar is hidden.
//
// The doctor app can ALSO run by live-loading the shared revivehc.in build with
// `?app=doctor` (the Capacitor server.url in capacitor.config.doctor.json). That
// lets the installed doctor APK auto-update on deploy — no rebuild per UI change.
// The `?app=doctor` marker is persisted to localStorage so in-app navigation
// (which drops the query string) keeps the doctor flavor.
function detectDoctor() {
  try {
    if ((process.env.REACT_APP_FLAVOR || '').toLowerCase() === 'doctor') return true
    if (typeof window === 'undefined') return false
    const param = new URLSearchParams(window.location.search).get('app')
    if (param === 'doctor') { try { localStorage.setItem('revive_flavor', 'doctor') } catch (e) {} return true }
    if (param === 'patient') { try { localStorage.removeItem('revive_flavor') } catch (e) {} return false }
    try { if (localStorage.getItem('revive_flavor') === 'doctor') return true } catch (e) {}
    return false
  } catch (e) { return false }
}

export const IS_DOCTOR_APP = detectDoctor()
